/**
 * 兩步驟驗證碼的輸入整理（給 MfaVerifyForm 用）。
 * 最後的判斷在會員中樞：中樞會去掉空白與連字號、轉大寫再比對，這裡只負責讓輸入框好用。
 */

export type MfaCodeMode = 'totp' | 'recovery'

/** 驗證器 App 的 6 位數：只留數字（貼上「123 456」也可以），最多 6 碼 */
export const normalizeTotpInput = (value: string): string => value.replace(/\D/g, '').slice(0, 6)

/** 備用碼（XXXXX-XXXXX）：轉大寫，只留英數、空白、連字號 */
export const normalizeRecoveryInput = (value: string): string =>
  value.toUpperCase().replace(/[^A-Z0-9\s-]/g, '').slice(0, 24)

/** 6 位數驗證碼輸入完整 */
export const isTotpComplete = (value: string): boolean => /^\d{6}$/.test(value)

/** 備用碼去掉空白與連字號之後是 10 碼英數，才算輸入完整 */
export const isRecoveryCodeComplete = (value: string): boolean => /^[A-Z0-9]{10}$/i.test(value.replace(/[\s-]/g, ''))

export const isMfaCodeComplete = (mode: MfaCodeMode, value: string): boolean =>
  mode === 'totp' ? isTotpComplete(value) : isRecoveryCodeComplete(value)

export const normalizeMfaInput = (mode: MfaCodeMode, value: string): string =>
  mode === 'totp' ? normalizeTotpInput(value) : normalizeRecoveryInput(value)
